jQuery(document).ready(function($) {

    const $body = $('body');

    $body.on('click', '.js-modal-trigger', function(e) {
        e.preventDefault();
        const $trigger = $(this);
        const target = $trigger.data('modal');
        $('[data-modal="'+target+'"]').toggleClass('active');
    });

    $body.on('click', '.js-files-select-modal-trigger', function(e) {
        e.preventDefault();
        $filesModal = $('.js-files-select-modal');
        if ( $filesModal.length ) {
            $filesModal.remove();
        }
        else {
            $('.js-files-select-modal').remove();
            const $trigger = $(this);
            const content = $trigger.parent().find('.js-modal-template').html();
            if ( content ) {
                $body.append(content);
            }
            window.history.pushState('forward', null, './#download');
        }
    });

    if (window.history && window.history.pushState) {
        $(window).on('popstate', function() {
            console.log('test');
            $filesModal = $('.js-files-select-modal');
            if ( $filesModal.length ) {
                $filesModal.remove();
            }
        });
    }

}); 